
import ResponsiveDialog from "./responsive-dialog.vue";
import storeClosed from "~/assets/images/storeClosed.svg";

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: false
  },
  data() {
    return {
      storeClosed
    };
  }
};
